import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { HtmlEditorComponent } from 'src/app/shared/html-editor/html-editor.component';

@Component({
  selector: 'app-signature',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HtmlEditorComponent,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule
  ],
  templateUrl: './signature.component.html',
  styleUrl: './signature.component.scss'
})
export class SignatureComponent {
  signatureContent = new FormControl(); // Signature content
  quillModule = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'], // Basic formatting
        ['link'], // Media options
        [{ list: 'ordered' }, { list: 'bullet' }], // Lists
        ['clean'], // Clear formatting
        ['speechToText'], // Add speech-to-text button
      ],
      handlers: {
        speechToText: () => {}, // Placeholder for now, managed in HtmlEditorComponent
      },
    },
  };

  constructor(
    private dialogRef: MatDialogRef<SignatureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Injected data
  ) {}

  saveSignature(): void {
    this.dialogRef.close({signature:this.signatureContent.value});
  }
}
